<template>
    <transition name="fade" mode="out-in">
        <div v-if="resource.ready && selects.ready">
            <div class="card mb-5">
                <div class="card-title" v-once>
                    <span v-if="editing">Абонемент – {{ entry.name }}</span>
                    <span v-else>Создать абонемент</span>
                </div>

                <form class="spaced-y-4" @submit.prevent="submit">
                    <div class="flex -mx-2">
                        <text-field
                            class="w-1/2 px-2"
                            title="Название"
                            v-model="entry.name"
                            :errors="errors.name"
                            required
                        />

                        <text-field
                            class="w-1/2 px-2"
                            title="Срок, меc."
                            v-model="entry.period"
                            :errors="errors.period"
                            required
                        />
                    </div>

                    <div class="flex -mx-2">
                        <text-field
                            type="number"
                            class="w-1/2 px-2"
                            title="Стоимость"
                            v-model="entry.price"
                            :errors="errors.price"
                            required
                        />
                    </div>

                    <hr class="mb-3" />

                    <div
                        class="inline-block"
                        v-if="!editing || can('edit-product')"
                    >
                        <button class="btn btn-primary">Сохранить</button>

                        <button
                            v-if="editing && can('remove-product')"
                            @click.prevent="destroy"
                            class="btn btn-danger"
                        >
                            Удалить
                        </button>
                    </div>
                </form>
            </div>

            <transactions
                v-if="can('access-transactions') && editing"
                modelType="product"
                :modelId="entry.id"
            />
        </div>
    </transition>
</template>

<script>
import ResourceForm from "@/components/Resource/ResourceForm";
import Transactions from "@/views/admin/billing/transactions/index";

export default {
    extends: ResourceForm,

    components: {
        Transactions,
    },

    data() {
        return {
            canUpdate: this.can("edit-product"),
            showAddModal: false,
            resource: {
                name: "admin.subscriptions",
                endpoint: "admin/products/subscriptions",
            },

            entry: {
                amount: 1,
                period: 12,
            },

            selects: {
                ready: false,
                pipelines: [],
            },

            pipeline_id: null,
            pipeline: {},
        };
    },

    methods: {
        setPipeline() {
            this.pipeline = this.selects.pipelines.find(
                (pipeline) => pipeline.id == this.pipeline_id
            );
        },

        async fetchSelects() {
            let vm = this;
            this.pipeline = this.selects.pipelines.find((pipeline) => {
                return !!pipeline.statuses.find((status) => {
                    return status.id == vm.entry.status_id;
                });
            });

            if (this.pipeline) {
                this.pipeline_id = this.pipeline.id;
            }

            this.selects.ready = true;
        },
    },

    mounted() {
        this.fetchSelects();
    },
};
</script>